import { createContext } from 'react'
import type { UseClientsReturn } from '@/types'

export const clientsContext = createContext<UseClientsReturn | undefined>(
  undefined,
)
